export default __webpack_public_path__ + "static/media/channelValue.4a6c91b5.jpg";